import React from 'react'
import { cn } from '@/lib/utils'
import { Calendar, LayoutGrid, Rows3 } from 'lucide-react'
import type { ViewMode } from '@/types/calendar'

interface ViewSwitcherProps {
  value: ViewMode
  onChange: (mode: ViewMode) => void
}

const views: { mode: ViewMode; label: string; icon: React.ElementType }[] = [
  { mode: 'calendar', label: 'Calendar', icon: Calendar },
  { mode: 'grid', label: 'Grid', icon: LayoutGrid },
  { mode: 'timeline', label: 'Timeline', icon: Rows3 },
]

export default function ViewSwitcher({ value, onChange }: ViewSwitcherProps) {
  return (
    <div className="inline-flex items-center rounded-lg border border-border/60 bg-white p-1 shadow-sm">
      {views.map(({ mode, label, icon: Icon }) => (
        <button
          key={mode}
          type="button"
          onClick={() => onChange(mode)}
          className={cn(
            'inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-all',
            value === mode
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
          )}
        >
          <Icon className="h-3.5 w-3.5" />
          {label}
        </button>
      ))}
    </div>
  )
}
